import * as React from "react";
import * as ReactDOM from "react-dom";
import { InputBase, InputContainer, IInputBaseProperties } from "../input";


export interface ITextBoxProperties extends IInputBaseProperties
{
    /**
     * Enthält alle Child-Elemente.
     */
    children?: JSX.Element | JSX.Element[],

    /**
     * Inline-Style.
     */
    style?: React.CSSProperties,

    /**
     * Label Text.
     */
    label?: string,

    /**
     * TextArea Zeilen.
     */
    rows?: number
}

export class TextArea extends React.Component<ITextBoxProperties>
{
    private getLabel()
    {
        if (this.props.label != null)
        {
            return <label htmlFor={this.props.id}>{this.props.label}</label>
        }
    }

    render()
    {
        return (
            <InputContainer style={this.props.style}>
                {this.getLabel()}
                <div className="textarea">
                    <InputBase isTextArea={true} {...this.props} />
                    {this.props.children}
                </div>
            </InputContainer>
        );
    }
}